import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { SEO } from '../../components/SEO';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';

export function LoginPage() {
  const { login, isLoggingIn, loginError } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    login({ email, password });
  };

  const error = loginError as Error | null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#E8EDF5] to-[#F0F2F8] px-4">
      <SEO title="Sign in" description="Sign in to Tractk to find your conversations and connections." />
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#6B8FD4] rounded-2xl mb-4">
            <span className="text-white font-bold text-3xl">T</span>
          </div>
          <h1 className="text-3xl font-bold text-[#1A2B3C]">Tractk</h1>
          <p className="text-neutral-500 mt-2">Connections by intention</p>
        </div>

        {/* Form */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-6">Sign in</h2>

          <form onSubmit={handleSubmit} className="space-y-5">
            <Input
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              autoComplete="email"
            />

            <Input
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="current-password"
            />

            {error && (
              <div className="bg-red-50 text-red-700 px-4 py-3 rounded-lg text-sm">
                {error.message || 'Incorrect email or password'}
              </div>
            )}

            <Button type="submit" className="w-full" size="lg" isLoading={isLoggingIn}>
              Sign in
            </Button>
          </form>

          <div className="mt-4 text-center">
            <Link to="/forgot-password" className="text-sm text-gray-500 hover:text-gray-700">
              Forgot password?
            </Link>
          </div>

          <div className="mt-6 text-center">
            <p className="text-gray-600">
              Don't have an account?{' '}
              <Link to="/signup" className="text-[#6B8FD4] hover:text-[#5A7EC2] font-medium">
                Create an account
              </Link>
            </p>
          </div>
        </div>

        {/* Demo credentials */}
        <div className="mt-6 bg-white/60 rounded-lg p-4 text-center">
          <p className="text-sm text-gray-600">
            <span className="font-medium">Demo account:</span> alice@example.com / Test1234!
          </p>
        </div>
      </div>
    </div>
  );
}
